import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { CAMERA_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, FAILED, HIDE, SHOW, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_CAMERAS_LIST = '_LOAD_CAMERAS_LIST';
export const LOAD_CAMERAS_STATUSES_LIST = '_LOAD_CAMERAS_STATUSES_LIST';
export const SET_SERVER_TIME_ZONE = '_SET_SERVER_TIME_ZONE';

export const loadCamerasList = createDeferredAction(CAMERA_MODULE + LOAD_CAMERAS_LIST);
export const loadCamerasListBegin = createAction(CAMERA_MODULE + LOAD_CAMERAS_LIST + BEGIN);
export const loadCamerasListSuccessful = createAction(CAMERA_MODULE + LOAD_CAMERAS_LIST + SUCCESSFUL);
export const loadCamerasListFailed = createAction(CAMERA_MODULE + LOAD_CAMERAS_LIST + FAILED);

export const loadCamerasStatusesList = createDeferredAction(CAMERA_MODULE + LOAD_CAMERAS_STATUSES_LIST);
export const loadCamerasStatusesListBegin = createAction(CAMERA_MODULE + LOAD_CAMERAS_STATUSES_LIST + BEGIN);
export const loadCamerasStatusesListSuccessful = createAction(CAMERA_MODULE + LOAD_CAMERAS_STATUSES_LIST + SUCCESSFUL);
export const loadCamerasStatusesListFailed = createAction(CAMERA_MODULE + LOAD_CAMERAS_STATUSES_LIST + FAILED);
export const setServerTimeZone = createDeferredAction(CAMERA_MODULE + SET_SERVER_TIME_ZONE);
export const setServerTimeZoneSuccessful = createAction(CAMERA_MODULE + SET_SERVER_TIME_ZONE + SUCCESSFUL);
export const setServerTimeZoneFailed = createAction(CAMERA_MODULE + SET_SERVER_TIME_ZONE + FAILED);
